import type { SVGProps } from 'react';

const SvgQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 42 32" {...props}>
    <path
      fill={props.color}
      d="M19.326 23.59c0 2.33-.9 4.333-2.699 6.007C14.9 31.2 12.704 32 10.041 32 6.946 32 4.5 30.908 2.7 28.724.9 26.539 0 23.954 0 20.969 0 14.198 1.835 9.101 5.506 5.68 9.177 2.257 13.244.364 17.706 0v7.427c-2.158.218-4.21 1.092-6.153 2.62-1.872 1.53-2.88 3.46-3.023 5.79a5.186 5.186 0 0 1 2.375-.547c2.663 0 4.715.765 6.154 2.294 1.512 1.529 2.267 3.53 2.267 6.006Zm22.674 0c0 2.33-.9 4.333-2.7 6.007C37.574 31.2 35.379 32 32.716 32c-3.096 0-5.543-1.092-7.342-3.276-1.728-2.185-2.591-4.77-2.591-7.755 0-6.771 1.799-11.868 5.398-15.29C31.85 2.257 35.918.364 40.38 0v7.427c-2.159.218-4.21 1.092-6.154 2.62-1.871 1.53-2.879 3.46-3.023 5.79a5.186 5.186 0 0 1 2.375-.547c2.664 0 4.715.765 6.155 2.294C41.244 19.113 42 21.114 42 23.59Z"
    />
  </svg>
);

export default SvgQuote;
